<template>
  <div>
    <b-row>
      <b-col>
        <h4 class="mt-3">{{ $t("workflow.cardFields") }}</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          hover
          :items="availableFields"
          :fields="previousStageFields"
          selectable
          select-mode="single"
          @row-selected="onSelectAvailable"
        >
        </b-table>
      </b-col>
      <b-col>
        <b-table
          hover
          :items="stage.cardFields"
          :fields="tableFields"
          selectable
          select-mode="single"
          @row-selected="onSelectAdded"
        >
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "StageCrudCardFields",
  components: {},
  props: {
    process: Object,
    stage: Object,
    availableStages: Array,
  },
  mixins: [],
  data() {
    return {
      previousStageFields: [
        {
          label: this.$t("geral.availableFields"),
          key: "displayName",
          sortable: true,
        },
      ],
      tableFields: [
        {
          label: this.$t("workflow.cardFields"),
          key: "displayName",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    availableFields() {
      let fields = [];
      let selectedFields = this.stage.cardFields;
      this.process.fields.forEach((field) => {
        if (!selectedFields.some((e) => e.id == field.id)) {
          fields.push(field);
        }
      });
      // this.stage.fields.forEach((field) => {
      //   if (!selectedFields.some((e) => e.id == field.id)) {
      //     fields.push(field);
      //   }
      // });
      // this.availableStages.forEach((stage) => {
      //   stage.fields.forEach((field) => {
      //     if (!selectedFields.some((e) => e.id == field.id)) {
      //       if (fields.indexOf(field) < 0) {
      //         fields.push(field);
      //       }
      //     }
      //   });
      // });
      return fields;
    },
  },
  mounted: function () {},
  methods: {
    onSelectAdded(items) {
      for (let item of items) {
        let selectedIndex = this.stage.cardFields.indexOf(item);
        if (selectedIndex >= 0) {
          this.stage.cardFields.splice(selectedIndex, 1);
        }
      }
    },
    onSelectAvailable(items) {
      for (let item of items) {
        this.stage.cardFields.push(item);
      }
    },
  },
  watch: {},
};
</script>